module.exports = __webpack_public_path__ + "static/img/nro.21849f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons/nro.png
// module id = tTi6
// module chunks = 0